// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// project imports
import akuaPagosReducer from "./slices/akuaPagos";
import calendarReducer from "./slices/calendar";
import cartReducer from "./slices/cart";
import chatReducer from "./slices/chat";
import configuracionReducer from "./slices/configuracionWeb";
import contactReducer from "./slices/contact";
import customerReducer from "./slices/customer";
import descuentoReducer from "./slices/descuento";
import globalReducer from "./slices/globalSlice";
import kanbanReducer from "./slices/kanban";
import mailReducer from "./slices/mail";
import menuReducer from "./slices/menu";
import negocioReducer from "./slices/negocio";
import pedidosReducer from "./slices/pedidos";
import productReducer from "./slices/product";
import shopReducer from "./slices/shop";
import snackbarReducer from "./slices/snackbar";
import sucursalReducer from "./slices/sucursal";
import surveyReducer from "./slices/survey";
import userReducer from "./slices/user";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "berry-",
    },
    cartReducer
  ),
  kanban: kanbanReducer,
  customer: customerReducer,
  contact: contactReducer,
  product: productReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  mail: mailReducer,
  user: userReducer,
  menu: menuReducer,
  negocio: negocioReducer,
  sucursal: sucursalReducer,
  pedidos: pedidosReducer,
  shop: shopReducer,
  descuento: descuentoReducer,
  configuracionWeb: configuracionReducer,
  survey: surveyReducer,
  global: globalReducer,
  akuaPagos: akuaPagosReducer,
});

export default reducer;
